export const FETCH_TOP_NAVIGATION_REQUEST = 'TOP_NAVIGATION/FETCH_TOP_NAVIGATION_REQUEST';
export const FETCH_TOP_NAVIGATION_FAILURE = 'TOP_NAVIGATION/FETCH_TOP_NAVIGATION_FAILURE';
export const FETCH_TOP_NAVIGATION_SUCCESS = 'TOP_NAVIGATION/FETCH_TOP_NAVIGATION_SUCCESS';
